export class AttendingScore {
  constructor(public score?,
              public observation?,
              public technician?,
              public monitoringUser?,
              public scoreInfo?,
              public scoreDate?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/attending-score.ts